import axios from "./axios-handler.service";
const BASE_URL = "/api/Planos";

export interface TipoPlano {
  idTipoPlano: number;
  nome: string;
  valor: number;
  valorOriginal: number;
  temDesconto: boolean;
  validade: number;
  ativo: boolean;
  descricaoValidade: string;
  validadeEmMeses: string;
  categoriaPlano: number;
}

export class PlanosService {
  static async listarTiposAtivosNaoGratuitos(): Promise<TipoPlano[]> {
    const response = await axios.get<TipoPlano[]>(
      `${BASE_URL}/ListarTiposAtivosNaoGratuitos`
    );
    return response.data;
  }
}